import styles from "./score-ring.module.scss";

interface ScoreRingProps {
  score: number; // 0-1
  size: number;
  strokeWidth?: number;
  children?: React.ReactNode;
}

export function ScoreRing({ score, size, strokeWidth = 3, children }: ScoreRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - Math.min(score, 1));

  return (
    <div
      className={styles.container}
      style={{ width: size, height: size }}
      role="img"
      aria-label={`Score: ${Math.round(score * 100)}%`}
    >
      <svg width={size} height={size} className={styles.svg}>
        <circle
          className={styles.track}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
        />
        <circle
          className={styles.fill}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{
            color: score >= 1 ? "var(--color-success)" : "var(--accent-foreground)",
          }}
        />
      </svg>
      {children && <div className={styles.center}>{children}</div>}
    </div>
  );
}
